import React from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight, Check } from "lucide-react";
import { SERVICES } from "@/mock";
import FinalCTA from "@/components/sections/FinalCTA";

const ServicesPage = () => {
  return (
    <div data-testid="services-page" className="bg-brand-bg">
      {/* Page Header */}
      <section className="pt-32 pb-16 lg:pt-40 lg:pb-24 border-b border-brand-border">
        <div className="max-w-[1400px] mx-auto px-6 lg:px-12">
          <div className="grid lg:grid-cols-12 gap-8 items-end">
            <div className="lg:col-span-8">
              <p className="text-xs font-bold uppercase tracking-[0.24em] text-brand-cta mb-6 flex items-center gap-3">
                <span className="block w-10 h-px bg-brand-cta" />
                Our Services
              </p>
              <h1 className="font-heading text-5xl sm:text-6xl lg:text-7xl font-black tracking-tighter text-brand-ink leading-[0.95]">
                Full-service <br />
                <span className="italic font-light">residential remodeling.</span>
              </h1>
            </div>
            <div className="lg:col-span-4">
              <p className="text-base lg:text-lg text-brand-inkSoft leading-relaxed">
                We're not a one-trick shop. From a single bathroom to a
                whole-home refresh, we have the in-house craftsmen to deliver
                it correctly &mdash; in one schedule, under one PM.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Services List - alternating layout */}
      <section className="py-16 lg:py-24">
        <div className="max-w-[1400px] mx-auto px-6 lg:px-12 flex flex-col gap-16 lg:gap-24">
          {SERVICES.map((service, i) => {
            const reverse = i % 2 === 1;
            return (
              <article
                key={service.slug}
                data-testid={`service-detail-${service.slug}`}
                className={`grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-16 items-center ${
                  reverse ? "lg:flex-row-reverse" : ""
                }`}
              >
                <div
                  className={`lg:col-span-7 img-hover-zoom aspect-[4/3] lg:aspect-[5/4] ${
                    reverse ? "lg:order-2" : ""
                  }`}
                >
                  <img
                    src={service.image}
                    alt={service.title}
                    className="w-full h-full object-cover"
                  />
                </div>

                <div
                  className={`lg:col-span-5 ${
                    reverse ? "lg:order-1" : ""
                  }`}
                >
                  <p className="text-xs font-bold uppercase tracking-[0.2em] text-brand-cta mb-4">
                    0{i + 1} &middot; {service.title}
                  </p>
                  <h2 className="font-heading text-3xl sm:text-4xl lg:text-5xl font-black tracking-tighter text-brand-ink mb-6 leading-[1]">
                    {service.short}
                  </h2>
                  <p className="text-base text-brand-inkSoft leading-relaxed mb-8">
                    {service.description}
                  </p>

                  <ul className="space-y-3 mb-10">
                    {service.bullets.map((b) => (
                      <li
                        key={b}
                        className="flex items-start gap-3 text-sm text-brand-ink"
                      >
                        <span className="w-5 h-5 mt-0.5 border border-brand-cta flex items-center justify-center shrink-0">
                          <Check
                            className="w-3 h-3 text-brand-cta"
                            strokeWidth={3}
                          />
                        </span>
                        {b}
                      </li>
                    ))}
                  </ul>

                  <Link
                    to="/contact"
                    data-testid={`service-cta-${service.slug}`}
                    className="inline-flex items-center gap-3 px-6 py-4 bg-brand-ink hover:bg-brand-cta text-white text-xs font-bold uppercase tracking-[0.16em] transition-colors"
                  >
                    Request a quote
                    <ArrowUpRight className="w-4 h-4" strokeWidth={2} />
                  </Link>
                </div>
              </article>
            );
          })}
        </div>
      </section>

      <FinalCTA />
    </div>
  );
};

export default ServicesPage;
